import { forwardRef } from 'react';

import type { DialogComboboxContentProps } from '../DialogCombobox';
import { DialogComboboxContent, DialogComboboxOptionList } from '../DialogCombobox';

export interface SelectV2ContentProps extends DialogComboboxContentProps {}

export const SelectV2Content = forwardRef<HTMLDivElement, SelectV2ContentProps>(
  ({ children, minWidth = 150, ...restProps }, ref) => {
    return (
      <DialogComboboxContent minWidth={minWidth} {...restProps} ref={ref}>
        <DialogComboboxOptionList>{children}</DialogComboboxOptionList>
      </DialogComboboxContent>
    );
  },
);
